import {useListView} from '../../core/ListViewProvider'
import {PaymentMethodsListToolbar} from './PaymentMethodListToolbar'
import {PaymentMethodsListGrouping} from './PaymentMethodsListGrouping'
import {PaymentMethodsListSearchComponent} from './PaymentMethodsListSearchComponent'

const PaymentMethodsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <PaymentMethodsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <PaymentMethodsListGrouping /> : <PaymentMethodsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PaymentMethodsListHeader}
